<template>
    <div>
        <div class="list-campaign"
            v-if="isLoaded && isHaveItem">
            <news-item
                v-for="(campaign, k) in campaigns"
                :key="k"
                :index="k"
                :lbl="lbl"
                :localeCode="localeCode"
                :campaign="campaign"
            ></news-item>
        </div>
        <div class="list-campaign list-empty"
            v-if="isLoaded && !isHaveItem">
            <div class="list-empty-content">
                <div class="empty-icon">
                    <img src="../../../assets/image/Tabbar/tabbar_news_inactive.png" />
                </div>
                <div class="empty-txt">{{lbl.news_list.news_empty}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import Account from "@/helper/AccountHelper.js";
//mixin
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
//component
import NewsItem from "./NewsItem.vue";
//service
import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign.js";
/**
 * property
 * @property {object} lbl (require) Text for component.
 * @property {boolean} isLoading (require) Loading status.
 * @property {object} initListConfig (require) Configuration for call api.
 * @property {object} initFilterConfig (require) Filter configuration for call api.
 * @property {object} busEvent (require) Bus event for parent component.
 * method
 * @method getList Get list of campaign for api.
 * @method initialLoadMore Initial scroll event to load more campaign.
 * @method loadMore Load more campaigns.
 * utility
 * @method hideLoading Hide loading screen.
 * @method showLoading Show loading screen.
 * bus event.
 * @event switchLang Reinitial campaign list with new language setup.
 * @event reInitList Reinitail campaign list.
 * @event toggleLoading Toggle loading value.
 */
export default {
    name: "news-list",
    mixins: [ErrorApiMixin],
    components: {
        NewsItem,
    },
    props: {
        lbl: Object,
        localeCode: Number,
        initListConfig: Object,
        initFilterConfig: Object,

        controller: Object,
    },
    data: function() {
        return {
            listConfig: {},
            filterConfig: {},

            campaigns: [],
            isLoading: false,
            isLoaded: false,
            isHaveItem: false,

            canLoadMore: true,
            isListLoading: false,
        };
    },
    created: function() {
        this.listConfig = this.initListConfig;

        //error handler
        this.alertModal = this.controller.alertModal;
        this.errorHandler = new ErrorHandler();
        this.errorHandler.setAlertModal(this.alertModal);
    },
    mounted: function() {
        this.getList();
    },
    beforeDestroy: function() {
        window.onscroll = function(){};
    },
    methods: {
        //initial
        initialLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.getList();
                }
            };
        },
        //method
        getList: function() {
            if (!this.listConfig.strConfigList) return;
            if (!this.canLoadMore) return;
            if (this.isListLoading) return;

            this.isListLoading = true;

            if (this.showLoading()) return;
            var strBzbsToken = Account.getToken();
            BzbsCampaign.apiGetCampaign(strBzbsToken, this.listConfig, null)
                .then(campaigns => {
                    this.listConfig.intSkip += this.listConfig.defaultTopAmount;
                    //check is there are more campaign.
                    if (campaigns &&
                        campaigns.length < this.listConfig.defaultTopAmount)
                        this.canLoadMore = false;
                        this.listConfig.isSeeMoreEnable = false;

                    //reinitialize list if no skip.
                    if (this.listConfig.intSkip ==
                        this.listConfig.defaultTopAmount)
                        this.campaigns = [];

                    for (var campaign of campaigns) {
                        //TODO: Add GA Tracking.
                        this.campaigns.push(campaign);
                    }

                    this.isListLoading = false;
                    this.isLoaded = true;
                    this.isHaveItem = this.campaigns.length > 0
                        ? true
                        : false;

                    this.$nextTick(() => {
                        this.initialLoadMore();
                    });

                    this.hideLoading();
                    
                }).catch(err => {
                    this.isLoaded = true;
                    this.isHaveItem = false;
                    this.isListLoading = false;
                    this.hideLoading();
                    this.errorResponse(err, this.errorHandler);
                });
        },
        // loadMore: function() {
        //     if (!this.listConfig.isSeeMoreEnable) return;

        //     setTimeout(() => {
        //         this.getList();
        //     }, 500);
        // },
        resetLoaded: function () {
            this.campaigns = [];
            this.isListLoading = false;
            this.canLoadMore =  true;
            this.isLoaded = false;
            this.isHaveItem = false;
        },
        reInitialList: function (data) {
            this.resetLoaded();
            this.listConfig = data.listConfig;
            // this.filterConfig = data.filterConfig;

            this.getList();
        },

        //loading
        showLoading: function () {
            if (this.isLoading) return true;

            this.isLoading = true;
            this.controller.loadingModal.show();

            return false;
        },
        hideLoading: function () {
            this.isLoading = false;
            this.controller.loadingModal.hide();
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";
@import "./campaignlist.scss";
</style>
